export class FetchMetrics {
  static readonly type = '[Dashboard] Fetch metrics';
}

export class FetchOfflineDevicesSummary {
  static readonly type = '[Dashboard] Fetch offline devices summary';
}
